<template>
    <div class="attachment" :class="{ 'error': error }">
        <label @dragover.prevent @drop.prevent="$emit('drop', $event)" :class="{ 'no-event': fileName }">
            <div class="placeholder" v-if="!fileName">
                Drop your file here, or <span>browse</span>
                <small>Supported file: {{ accept }}</small>
                <input @change="$emit('upload', $event)" type="file" :accept="accept" ref="file" hidden>
                <small class="error--message" v-if="error">Invalid File Format</small>
            </div>
            <div v-else class="upload">
                <div class="upload--details">
                    <slot>
                            <span class="filename">File name: {{ fileName }}</span>
                            <AppProgress :progress="progress" />
                    </slot>
                </div>
                <AppButton v-if="canRemove" modifier="small-danger" @click.self.prevent="$emit('remove')">
                    Remove
                </AppButton>
            </div>
        </label>
    </div>
</template>

<script>
import AppProgress from '@/components/AppProgress'
import AppButton from '@/components/AppButton'

export default {
	props: {
		fileName: {
			type: String
		},
		accept: {
			type: String,
			default: '.mp3,.wav,.aac'
		},
		progress: {
			type: [Number, String],
			default: 0
		},
		error: {
			type: Boolean,
			default: false
		},
		canRemove: {
			type: Boolean,
			default: false
		}
	},
	components: {
		AppButton,
		AppProgress
	}
}
</script>

<style lang="scss" scoped>
.attachment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1.5px solid $primary;
    border-style: dashed;
    margin: 16px 0;
    text-align: center;

    &.error {
        border-color: $danger;
    }

    small.error--message {
        color: $danger;
        font-weight: bold;
    }

    .upload {
        display: flex;
        padding: 12px;
        width: 100%;

        .app-button {
            align-self: center;
            margin: 0 auto;
            z-index: +1;
            pointer-events: all;
        }

        &--details {
            flex-basis: 80%;
            align-self: flex-start;
            text-align: left;
            // margin: 0 10px;
        }
        .filename {
            word-break: break-all;
            text-overflow: ellipsis;
        }
    }
    .music-controls {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        z-index: +99;

        span.control {
            pointer-events: all;
            cursor: pointer;

            &:hover {
                opacity: .8;
                transition: .3s;

                path {
                    fill: $primary;
                }
            }
        }
    }

    .app-progress-bar {
        margin-top: 8px;
    }

    label {

        &.no-event {
            pointer-events: none;
        }

        .placeholder {
            font-size: 1.2em;
            user-select: none;
            cursor: pointer;
            width: 100%;
            padding: 20px 0;

            small {
                display: block;
                opacity: .8;
                margin-top: 5px;
            }
        }
    }

    span {
        color: $secondary;
    }
}
</style>
